export default [
  {
    area: 'Hồ Chí Minh',
    shops: [
      {
        shop: "Hai Bà Trưng",
        address: "380B Hai Bà Trưng, P. Tân Định, Q.1, TP.HCM"
      },
      {
        shop: "SC VivoCity",
        address: "Tầng 3 Trung tâm thương mại SC VivoCity - 1058 Nguyễn Văn Linh, P. Tân Phong, Q.7, TP.HCM"
      },
      {
        shop: "Nguyễn Huệ",
        address: "109-111 Nguyễn Huệ, P. Bến Nghé, Q.1, TP.HCM"
      },
      {
        shop: "Nam Long",
        address: "TTTM Vincom Nam Long - 75 Trần Trọng Cung, P.Tân Thuận Đông, Q.7, TP.HCM"
      },
      {
        shop: "Bình Tân",
        address: "Tầng 1 AEON MALL Bình Tân, Số 1 đường số 17A, Khu phố 11, Phường Bình Trị Đông B, Quận Bình Tân, TPHCM"
      },
      {
        shop: "Quang Trung",
        address: "665 Quang Trung, P.11, Q. Gò Vấp, TPHCM"
      },
      {
        shop: "Võ Văn Ngân",
        address: "190 Võ Văn Ngân, Quận Thủ Đức, TPHCM"
      },
      {
        shop: "Đồng Khởi",
        address: "Lô L1, Tầng B2, TTTM Vincom Đồng Khởi, số 72 Lê Thánh Tôn, Phường Bến Nghé, Quận 1, TPHCM"
      },
      {
        shop: "Ba Tháng Hai",
        address: "L1-23, Vincom_3/2, số 3C, Đường 3/2, Quận 10, TPHCM"
      },
      {
        shop: "Nguyễn Trãi",
        address: "85A - 85B, Nguyễn Trãi, Quận 5, TPHCM"
      },
      {
        shop: "Lotte Mart Quận 7",
        address: "Lô 2F4 Tầng 2, Lotte Mart Quận 7, số 469, Nguyễn Hữu Thọ, Phường Tân Hưng, Quận 7, TPHCM"
      },
      {
        shop: "Lotte Quận 11",
        address: "Lô 4F-05 tầng 4, Lotte Mart Quận 11, 968 Đường 3/2, Phường 15, Quận 11, TPHCM"
      },
      {
        shop: "Vạn Hạnh Mall",
        address: "TTTM Vạn Hạnh - Lô 2-11, Tầng 2, Số 11 Sư Vạn Hạnh, Phường 12, Quận 10, Thành phố Hồ Chí Minh"
      },
      {
        shop: "Đề Thám",
        address: "195 Đề Thám, P. Phạm Ngũ Lão, Quận 1, TP.HCM "
      },
      {
        shop: "Nguyễn Văn Luông",
        address: "341 Nguyễn Văn Luông, phường 12, quận 6, Tp. HCM "
      },
      {
        shop: "Cách Mạng Tháng 8",
        address: "488 - 499 Cách Mạng Tháng 8, Phường 11, Quận 3, TPHCM"
      },
      {
        shop: "Trần Phú ",
        address: "348-350 Trần Phú, Phường 7, Quận 5, HCM"
      },
    ]
  },
  {
    area: 'Bình Dương',
    shops: [{
      shop: "Bình Dương",
      address: "Tầng 1, Gian hàng F17 - 18 - 19 AEON MALL BÌNH_DƯƠNG - Số 1 Đại Lộ Bình Dương, Khu phố Bình Giao, Phường Thuận Giao, Thị xã Thuận An, Tỉnh Bình Dương"
    }]
  },
  {
    area: 'Hà Nội',
    shops: [{
      shop: "Hàng Ngang",
      address: "28 Hàng Ngang, P.Hàng Đào, Q.Hoàn Kiếm, Hà Nội"
    },
    {
      shop: "Artemis ",
      address: "Gian hàng T129, Trung tâm thương mại The Artemis - 03 Lê Trọng Tấn, P.Khương Mai, Q.Thanh Xuân, Hà Nội"
    },
    {
      shop: "Hàng Gai",
      address: "13 Hàng Gai, Q. Hoàn Kiếm, Hà Nội"
    },
    {
      shop: "Thái Hà",
      address: "41 Thái Hà, Phương Trung Liệt, Quận Đống Đa, Hà Nội"
    },
    {
      shop: "Tràng Tiền",
      address: "56 Tràng Tiền, Quận Hoàn Kiếm, Hà Nội "
    }]
  },
  {
    area: "Cà Mau",
    shops: [
      { shop: "Cà Mau", address: "21 Trần Hưng Đạo, Phường 5, TP Cà Mau" }
    ]
  },
  {
    area: "Lạng Sơn",
    shops: [
      { shop: "Lạng Sơn", address: "GH L1-07 tầng 1 TTTM Vincom Lạng Sơn ,ngã tư Hùng Vương và Trần Hưng Đạo, TP.Lạng Sơn" }
    ]
  },
  {
    area: "Đà Nẵng",
    shops: [{ shop: "Đà Nẵng", address: "L2 – 05G, Vincom Đà Nẵng, số 910A, Ngô Quyền, P. An Hải Bắc, Q. Sơn Trà, Đà Nẵng" }]
  },
  {
    area: "Bắc Ninh",
    shops: [{ shop: "Bắc Ninh", address: "349 Trần Hưng Đạo, Phường Đại Phúc, TP.Bắc Ninh, Tỉnh Bắc Ninh" }]
  },
  {
    area: "Cần Thơ",
    shops: [{ shop: "Cần Thơ", address: "1F5 tầng 1, Lotte Mart Cần Thơ 84 Mậu Thân, Phường An Hòa, Quận Ninh Kiều, TP Cần Thơ" }]
  },
  {
    area: "An Giang",
    shops: [{ shop: "An Giang", address: "1242 Trần Hưng Đạo, P. Mỹ Bình, TP. Long Xuyên, Tỉnh An Giang" }]
  },
  {
    area: "Vũng Tàu",
    shops: [{ shop: "Vũng Tàu", address: "Lotte Mart Vũng Tàu - 28 Đường 3T2, Phường 8, TP. Vũng Tàu" }]
  },
  {
    area: "Trà Vinh ",
    shops: [{ shop: "Trà Vinh ", address: "Lô L1 - 01, tầng L1, TTTM VINCOM, số 24, Nguyễn Thị Minh Khai, khóm 3, phường 2, Tp. Trà Vinh " }]
  },
  {
    area: "Sơn La ",
    shops: [{ shop: "Sơn La ", address: "Lô L1 - 06, tầng L1, TTTM VINCOM, Tp. Sơn La, Tỉnh Sơn La " }]
  }
]



// WEBPACK FOOTER //
// ./helpers/mumuso-ddress.js